import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/Banner/honarable-banner.webp";
import patron from "../../Images/Hon'ble Persons/Shri Mahesh Agrawal.webp"

const AboutUs = () => {
    return (
        <>
            <title>ISBM University: Honorable Patron Vision for Excellence</title>
            <meta
                name="description"
                content="ISBM University - Learn about our commitment to nurturing excellence in quality and affordable education. Discover the guiding influence behind our success."
            />

            <meta
                name="SearchEngines"
                content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
            />
            <meta name="Robots" content="INDEX, FOLLOW" />
            <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
            <meta name="Robots" content="INDEX,ALL" />
            <meta name="YahooSeeker" content="INDEX, FOLLOW" />
            <meta name="msnbot" content="INDEX, FOLLOW" />
            <meta name="googlebot" content="Default, follow" />
            <meta name="owner" content="isbmuniversity.edu.in/" />
            <meta name="language" content="English" />
            <meta name="revisit-after" content="2 days" />
            <meta
                property="og:title"
                content="ISBM University: Honorable Patron Vision for Excellence"
            />
            <meta
                property="og:description"
                content="ISBM University - Learn about our commitment to nurturing excellence in quality and affordable education. Discover the guiding influence behind our success. "
            />
            <meta
                property="og:url"
                content="https://isbmuniversity.edu.in/honorable-patron/"
            />
            <meta
                property="og:image"
                content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
            />
            <meta property="og:image:alt" content="ISBM University" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="ISBM University" />
            <meta
                name="twitter:title"
                content="ISBM University: Honorable Patron Vision for Excellence"
            />
            <meta
                name="twitter:description"
                content="ISBM University - Learn about our commitment to nurturing excellence in quality and affordable education. Discover the guiding influence behind our success."
            />
            <meta
                name="twitter:image:src"
                content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
            />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@ISBMUniversity" />
            <meta name="twitter:creator" content="@ISBMUniversity" />
            <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
            <meta property="twitter:account_id" content="758619542734053376" />
            <meta
                name="keywords"
                content="Educational Values , ISBM University , Commitment to Education"
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Patron's Message</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Hon'ble Vice Chancellor
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="vc-section ptb-50">
                <div className="container-xxl">
                    <div className="vc-container">
                        <div className="vc-image-container">
                            <div className="vc-image-wrapper shadow-sm">
                                <img src={patron} alt="Prof. (Dr.) Anand Mahalwar" className="vc-image" />
                                <div className="vc-image-overlay"></div>
                            </div>
                            <div className="vc-title-box">
                                <span className="vc-designation">Hon'ble Patron</span>
                                <h2 className="vc-name">Shri Mahesh Agrawal</h2>
                            </div>
                        </div>

                        <div className="vc-content">
                            <div className="vc-message">
                                <p>
                                    <span className="fw-bold">ISBM University was established in the year 2016 with an objective to cater the multifaceted educational needs of the millions.</span> Its philosophy includes offering multiple courses and programmes for the students, preparing them to become successful in life and eventually to become responsible citizens of the country. We encourage them to develop their personality, by metamorphosing and nurturing them to become employable as well as venture into entrepreneurship. In a nutshell, we take all our efforts for academic growth & skill development of the students.
                                </p>
                                <div className="vc-highlight-box fw-semibold">
                                    <p>
                                        Knowledge is the key to unlock the career of young men and women. ISBM University provides the platform for learning & research. Problem solving & decision making are dual objectives of learning.
                                    </p>
                                </div>
                                <p className="p-0">
                                    The challenges are accepted in collaboration with the stakeholder's viz. other Universities, research institutions, members of the faculty & society at large. The academic programmes are need-based catering to the needs of mankind. Excellence & relevance is a key parameter. It is to be set by the academic community & drive to achieve it. It is equally important we keep close to our communities both in the interest of our country and our neighborhood. It will help to ensure the on-going relevant academic programmes. I welcome all and congratulate the students, parents for choosing our University. I am sure that all stakeholders will be immensely benefited by an excellent academic pursuit.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default AboutUs;
